import { Title as NgTitle } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "../config/config";
/**
 * A service that can be used to set the title of the current HTML document.
 *
 * This wraps Angular's native Title service in order to ensure the titles
 * consistency, i.e. mostly append the site name to the titles for now.
 */
var Title = /** @class */ (function () {
    function Title(titleService, siteName) {
        this.titleService = titleService;
        this.siteName = siteName;
    }
    /**
     * Allows to set the page title.
     */
    Title.prototype.setTitle = function (newTitle) {
        this.titleService.setTitle(newTitle + " | " + this.siteName);
    };
    /*
     * we explicitly don't want to re-export getTitle here as there should not
     * be any reason to.
     */
    /*
     * PRIVATE: only to be used by the Title component
     * this allows the title to be reset on navigations
     */
    Title.prototype.setDefaultTitle = function () {
        this.titleService.setTitle(this.siteName);
    };
    Title.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Title_Factory() { return new Title(i0.ɵɵinject(i1.Title), i0.ɵɵinject(i2.SITE_NAME)); }, token: Title, providedIn: "root" });
    return Title;
}());
export { Title };
